import axiosSecurity from '../axios/axiosSecurity'

export default class DepartamentoService {
  static async get() {
    return axiosSecurity.get('departamentos').then(res => res.data.data)
  }

  static async getById(departamentoId) {
    return axiosSecurity.get(`departamentos/${departamentoId}`).then(res => res.data.data)
  }

  static async ativarOuInativar(departamentoId, body) {
    return axiosSecurity.put(`departamentos/${departamentoId}/ativado`, body)
  }

  static async criar(body) {
    return axiosSecurity.post('departamentos', body)
  }

  static async update(departamentoId, body) {
    return axiosSecurity.put(`departamentos/${departamentoId}`, body)
  }
}
